import React from "react";
import { KanbanColumn } from "./KanbanColumn";
import { Column, Task2 } from "@/types/tasks";

interface KanbanBoardProps {
  columns: Column[];
  onTaskMove: (taskId: string, newStatus: string) => void;
  onTaskClick: (task: Task2) => void;
  onColumnUpdate: (columns: Column[]) => void;
  onCreateTask: (taskData: Partial<Task2>) => void;
  onOpenTaskModal: (taskData: Partial<Task2>) => void;
}

export function KanbanBoard({ columns, onTaskMove, onTaskClick, onColumnUpdate, onCreateTask, onOpenTaskModal }: KanbanBoardProps) {
  const handleDragOver = (e: React.DragEvent) => {
    e.preventDefault();
  };

  const handleDrop = (e: React.DragEvent, columnId: string) => {
    e.preventDefault();
    const taskId = e.dataTransfer.getData("taskId");
    if (taskId) {
      onTaskMove(taskId, columnId);
    }
  };

  return (
    <div className="flex gap-3 overflow-x-auto pb-4">
      {columns.map((column) => (
        <KanbanColumn
          key={column.id}
          column={column}
          onTaskClick={onTaskClick}
          onDragOver={handleDragOver}
          onDrop={(e) => handleDrop(e, column.id)}
          onColumnUpdate={onColumnUpdate}
          onCreateTask={onCreateTask}
          onOpenTaskModal={onOpenTaskModal}
        />
      ))}
    </div>
  );
}